module.exports = __webpack_public_path__ + "img/horizontal_6_5_pp3_7016.5a55fde9.png";